import React, { useState } from 'react';
import { XIcon, ChevronDownIcon } from 'lucide-react';
interface FAQModalProps {
  isOpen: boolean;
  onClose: () => void;
}
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '¿Qué es SamboCard?',
  answer: 'SamboCard es tu tarjeta de beneficios 100% gratuita que te permite acceder a descuentos exclusivos y promociones en cientos de comercios, instituciones y emprendimientos afiliados.'
}, {
  question: '¿Cuánto cuesta la tarjeta?',
  answer: 'SamboCard es completamente gratuita, tanto la afiliación como su uso. No tiene costo de emisión, mantenimiento ni renovación. Es gratis para siempre.'
}, {
  question: '¿Cómo obtengo mi SamboCard?',
  answer: 'Es muy simple: completa el formulario de inscripción con tus datos (tipo de documento, número, nombres, apellidos, teléfono y email), acepta los términos y condiciones, y recibirás tu tarjeta digital de inmediato. También puedes descargar nuestra app para tener tu tarjeta siempre a mano.'
}, {
  question: '¿Dónde puedo usar mi tarjeta?',
  answer: 'Puedes usar tu SamboCard en cientos de lugares afiliados: comercios, restaurantes, tiendas, instituciones educativas, centros de salud, emprendimientos y más. La lista de lugares afiliados está disponible en nuestra app y sitio web.'
}, {
  question: '¿Qué tipo de beneficios ofrece?',
  answer: 'Los beneficios incluyen descuentos directos en compras, promociones especiales, servicios preferenciales, obsequios y otros incentivos según cada comercio afiliado. Cada lugar define sus propios beneficios exclusivos para usuarios de SamboCard.'
}, {
  question: '¿La tarjeta tiene vencimiento?',
  answer: 'No, tu SamboCard tiene vigencia indefinida. Puedes usarla cuando quieras sin preocuparte por renovaciones o fechas de vencimiento.'
}, {
  question: '¿Puedo compartir mi tarjeta con otras personas?',
  answer: 'No, la SamboCard es personal e intransferible. Está vinculada a tu documento de identidad y solo puede ser usada por el titular registrado.'
}, {
  question: '¿Cómo sé qué comercios están afiliados y sus beneficios?',
  answer: 'Puedes consultar el listado completo de comercios afiliados y sus beneficios específicos en nuestra app móvil o en la sección de "Comercios Afiliados" de nuestro sitio web. Cada comercio detalla sus promociones vigentes.'
}, {
  question: '¿Qué hago si pierdo acceso a mi tarjeta digital?',
  answer: 'Si pierdes acceso a tu tarjeta digital, simplemente descarga nuevamente la app o accede a tu cuenta desde nuestro sitio web con tu email registrado. Tu tarjeta seguirá activa y podrás recuperarla fácilmente.'
}, {
  question: '¿Cómo puede mi negocio ser parte de SamboCard?',
  answer: 'Si tienes un comercio, institución o emprendimiento y quieres ofrecer beneficios a nuestros usuarios, contáctanos a aliados@sambocard.com. Nuestro equipo te explicará cómo sumarte al programa de aliados.'
}, {
  question: '¿Mis datos personales están protegidos?',
  answer: 'Sí, protegemos tus datos personales conforme a la legislación vigente. Solo usamos tu información para fines informativos y promocionales del programa. No compartimos tus datos con terceros sin tu consentimiento. Consulta nuestra Política de Privacidad para más detalles.'
}, {
  question: '¿Hay límite de uso de los beneficios?',
  answer: 'Los descuentos son ilimitados, pero cada comercio puede establecer sus propias condiciones (vigencia, stock, montos mínimos de compra, etc.). Te recomendamos verificar las condiciones específicas de cada beneficio antes de usarlo.'
}];
export function FAQModal({
  isOpen,
  onClose
}: FAQModalProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  if (!isOpen) return null;
  const toggleQuestion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-18">
      <div className="relative w-full max-w-4xl bg-gray-900 border-2 border-yellow-600/30 rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto" data-id="element-19">
        {/* Close button */}
        <button onClick={onClose} className="sticky top-4 float-right mr-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-800 hover:bg-gray-700 transition-colors z-10" data-id="element-20">
          <XIcon className="w-5 h-5 text-gray-400" data-id="element-21" />
        </button>

        {/* Header */}
        <div className="p-8 md:p-12" data-id="element-22">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-23">
            Preguntas{' '}
            <span className="bg-gradient-to-r from-yellow-400 to-yellow-200 bg-clip-text text-transparent" data-id="element-24">
              Frecuentes
            </span>
          </h1>
          <p className="text-gray-400 mb-8" data-id="element-25">
            Encuentra respuestas a las preguntas más comunes sobre SamboCard
          </p>

          {/* FAQ Accordion */}
          <div className="space-y-4" data-id="element-26">
            {faqs.map((faq, index) => <div key={index} className="border border-yellow-600/20 rounded-lg overflow-hidden bg-gray-800/50" data-id="element-27">
                <button onClick={() => toggleQuestion(index)} className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-800/80 transition-colors" data-id="element-28">
                  <span className="font-semibold text-white pr-4" data-id="element-29">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-yellow-400 flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-30" />
                </button>
                {openIndex === index && <div className="px-6 py-4 border-t border-yellow-600/20 bg-gray-900/50" data-id="element-31">
                    <p className="text-gray-300 leading-relaxed" data-id="element-32">
                      {faq.answer}
                    </p>
                  </div>}
              </div>)}
          </div>

          {/* Contact CTA */}
          <div className="mt-8 p-6 bg-gradient-to-br from-yellow-600/10 to-yellow-400/5 border border-yellow-600/20 rounded-lg" data-id="element-33">
            <p className="text-gray-300 text-center" data-id="element-34">
              ¿No encontraste lo que buscabas?{' '}
              <a href="mailto:contacto@sambocard.com" className="text-yellow-400 hover:text-yellow-300 font-semibold underline" data-id="element-35">
                Contáctanos
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>;
}